export const pl = {
    myGeotabLogin: {
        loginText: 'Zaloguj się',
        registerText: 'Rejestrować się',
    },
    transportationContactForm: {
        title: 'Zoptymalizuj swoją flotę już dziś',
        formField: {
            firstName: 'Imię',
            lastName: 'Nazwisko',
            company: 'Nazwa firmy',
            email: 'E-mail',
            selectCountry: 'Kraj',
            phone: 'Numer telefonu',
            city: 'Miasto',
            consentTextSentences: [
                'Czy chceszotrzymywać informacje marketingowe dotyczące produktów, usług i wydarzeń Geotab? Twoje informacje będą wykorzystywane zgodnie z ',
            ],
            consentLinkText: 'polityką prywatności firmy Geotab.',
            consentLink: 'https://docs.google.com/document/d/1sVygLN02w2xNovFY4q5vw-oAzfYxCd7WLhyToElgDbs/pub',
            submit: 'Wyślij',
        },
    },
    regionSelection: {
        seo: {
            title: 'Wybór regionu',
            description:
                'Wybierz swój kraj lub region, aby dowiedzieć się o urządzeniach do śledzenia pojazdów i oprogramowaniu do zarządzania flotą Geotab.',
        },
        title: 'Wybierz region',
        regions: {
            northSouthAmerica: 'Ameryka Północna i Południowa',
            europe: 'Europa',
            asiaAustraliaMiddleEast: 'Azja, Australia i Bliski Wschód',
        },
    },
    search: {
        seo: {
            title: 'Wyniki wyszukiwania dla',
        },
        search: 'Szukaj',
        searchBarPlaceholder: 'Szukaj podobnych tematów, artykułów, dokumentów i nie tylko.',
        searchResults: 'wyniki wyszukiwania',
        showing: 'Widocznych',
        of: 'z',
        results: 'wyników',
        noResults: {
            sorryMessage: 'Przepraszamy, nie możemy znaleźć wyników dla',
            invalidSearch: 'Przepraszamy, wprowadzone dane wyszukiwania są nieprawidłowe.',
            searchTips: 'Wskazówki wyszukiwania',
            spellingCheck: 'Sprawdź pisownię i spróbuj ponownie.',
            simplerTerms: 'Szukaj prostszych, krótszych haseł.',
            lessSpecific: 'Szukaj czegoś mniej konkretnego.',
            differentWords: 'Spróbuj użyć innych słów kluczowych lub spróbuj wybrać inny zakres dat.',
        },
        salesforce: {
            formLanguage: 'Polish PL',
        },
        filter: {
            contentType: 'Typ treści',
            filterButtonText: 'Filtr',
            applyFilters: 'Zastosuj filtry',
            clearFilters: 'Wyczyść filtry',
        },
        dateSelection: {
            dateUpdated: 'Data aktualizacji',
            all: 'Wszystkie',
            30: 'Ostatnie 30 dni',
            90: 'Ostatnie 90 dni',
            365: 'Ostatni rok',
        },
    },
    entityHomeNames: {
        blogArticle: 'Blog',
        pressReleaseArticle: 'Informacje prasowe',
        whitePaperArticle: 'Białe księgi',
        successStoryArticle: 'Historie sukcesu',
        glossaryArticle: 'Słownik',
    },
    entityNames: {
        blogArticle: 'Wpis na blogu',
        pressReleaseArticle: 'Informacja prasowa',
        whitePaperArticle: 'Biała Księga',
        successStoryArticle: 'Studium przypadku',
        page: 'Strona',
        author: 'Autor',
        category: 'Kategoria',
        tag: 'Tag',
        video: 'Wideo',
        document: 'Dokument',
        glossaryArticle: 'Słownik',
    },
    formPlaceholders: {
        firstNamePlaceholder: 'Wpisz imię\u2026',
        lastNamePlaceholder: 'Wpisz nazwisko\u2026',
        phonePlaceholder: 'Wprowadź numer telefonu\u2026',
        emailPlaceholder: 'Wpisz e-mail\u2026',
        companyPlaceholder: 'Wpisz firmę\u2026',
        yourCompanyPlaceholder: '',
        cityPlaceholder: 'Wpisz miasto\u2026',
        commentsPlaceholder: '',
        fleetPlaceholder: 'Wybierz wielkość floty\u2026',
        approxFleetPlaceholder: '',
        countryPlaceholder: 'Wybierz kraj\u2026',
        fullNamePlaceholder: '',
        messagePlaceholder: '',
        identityPlaceholder: '',
        surnamePlaceholder: '',
        statePlaceholder: '',
        provincePlaceholder: '',
        titlePlaceholder: 'Wybierz tytuł\u2026',
        userTitlePlaceholder: 'Wpisz swoją nazwę stanowiska\u2026',
        cargoPlaceholder: '',
        clientPlaceholder: 'Pomóż nam Cię zidentyfikować\u2026',
        industryPlaceholder: 'Wybierz kategorię branży\u2026',
        subIndustryPlaceholder: 'Wybierz kategorię podbranży\u2026',
    },
    formTranslations: {
        firstName: 'Imię',
        lastName: 'Nazwisko',
        company: 'Nazwa firmy',
        email: 'E-mail',
        phone: 'Numer telefonu',
        city: 'Miasto',
        country: 'Kraj',
        interest: 'Obszar zainteresowań',
        industry: 'Branża',
        subIndustry: 'Podbranża',
        client: 'Typ klienta',
        fleetSize: 'Wielkość floty',
        submit: 'Wyślij',
        yes: 'TAk',
        no: 'Nie',
        yesToProceed: 'Wybierz Tak z góry, aby kontynuować',
        checkedToProceed: 'Aby kontynuować, zaznacz powyższe pole wyboru',
        title: 'Tytuł',
        userTitle: 'Twój tytuł',
        forceMultiPick: 'Wybierz co najmniej dwie opcje',
    },
    authorBiography: {
        authorOverview: {
            leanMoreAbout: 'Dowiedz się więcej o {authorName}',
        },
    },
    micrositeForm: {
        tooltip: {
            pleaseFillOutThisField: 'Proszę wypełnić to pole',
            pleaseSelectAnItem: 'Wybierz pozycję z listy',
        },
        title: 'Zoptymalizuj swoją flotę już dziś',
        subTitle:
            'Pokażemy Ci, jak proste jest korzystanie z naszego oprogramowania internetowego i urządzeń telematycznych do zarządzania flotą.',
        countryName: '',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        company: 'Firma',
        email: 'E-mail',
        fleetSize: 'Wielkość floty',
        phone: 'Telefon',
        country: 'Kraj',
        city: 'Miejscowość',
        state: 'Stan/Prowincja',
        submitButton: 'Wyślij',
    },
    blogTableContent: {
        title: 'Spis treści',
    },
    blogInfo: {
        readMinutes: 'do przeczytania w 5 minut',
    },
    noBlogsFound: {
        forAuthor: 'Nie znaleziono blogów autora',
        forCategory: 'Nie znaleziono blogów w kategorii',
        forTag: 'Nie znaleziono wyników za pomocą znacznika',
        noArticlesFound: 'Nie znaleziono żadnych wyników! Spróbuj dostosować filtry.',
    },
    requestDemo: {
        optimizeYourFleetToday: 'Optimize your fleet today',
        formField: {
            leadSource: 'Geotab Demo Form',
            firstName: 'Imię',
            lastName: 'Nazwisko',
            company: 'Firma',
            email: 'Email',
            selectFleetSize: 'Wybierz wielkość floty',
            phone: 'Telefon',
            selectCountry: 'Wybierz kraj',
            city: 'Miejscowość',
            industry: 'Select Industry',
            consentText:
                'Chcesz otrzymywać informacje marketingowe dotyczące produktów, usług i wydarzeń organizowanych przez Geotab? Twoje dane będą przechowywane i wykorzystywane zgodnie z <a href="https://docs.google.com/document/d/13ipaGvtTOT4FvVwk3qKMmpgN3rTIAafomuU4KGLidPQ/edit#heading=h.gjdgxs" rel="noopener" target="_blank">polityką prywatności</a> Geotab.',
            requestAFreeDemo: 'Request a free demo',
            formTitle: 'Sign up for a FREE demo',
        },
    },
    contactUsForm: {
        firstName: 'Imię',
        lastName: 'Nazwisko',
        phone: 'Telefon',
        email: 'Email',
        company: 'Firma',
        fleetSize: 'Fleet Size',
        country: 'Country',
        city: 'Miejscowość',
        comments: 'Questions/Comments:',
        checkboxText:
            'Yes, I would like to receive marketing communications regarding Geotab products, services, and events. Your information will be used in accordance with Geotab’s privacy policy.',
        submit: 'Submit',
        languageCode: 'English Global',
        consentTextEU:
            'Chcesz otrzymywać informacje marketingowe dotyczące produktów, usług i wydarzeń organizowanych przez Geotab? Twoje dane będą przechowywane i wykorzystywane zgodnie z polityką prywatności Geotab.',
        yes: 'Tak',
        no: 'Nie',
    },
    aboutAuthor: {
        about: 'About',
        currentRole: 'Current role',
        experties: 'Expertise',
        accomplishments: 'Accomplishments',
        education: 'Education',
        publications: 'Publications',
    },
    breadcrumb: {
        home: 'Home',
    },
};
